import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PAYMENT_URL } from 'utils';

const Payment = () => {
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries([...searchParams]);

  const jsonToQueryString = (params = {}) => {
    // cno는 필수 파라미터 - 기본값
    const queryString = Object.entries(params)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join('&');

    // 쿼리 문자열 반환 (params가 없는 경우 빈 문자열 반환)
    return queryString ? `?${queryString}` : '';
  };

  React.useEffect(() => {
    if (queryParams) {
      if (!queryParams.isUpdated) {
        window.alert(
          '결제 서비스를 위한 필수 업데이트가 존재합니다!\n앱 업데이트 후 진행해주세요.'
        );
        return;
      }

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = PAYMENT_URL;
      form.target = '_self';

      Object.entries(queryParams).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; // 사용자에게는 보이지 않도록 hidden으로 설정
        input.name = key; // input의 name 속성은 객체의 key
        input.value = value; // input의 value 속성은 객체의 value
        form.appendChild(input);
      });

      form.sndReply.value = `${form.sndReply.value}${jsonToQueryString(
        queryParams
      )}`;

      document.body.appendChild(form);
      form.submit();
    }
  }, [queryParams]);

  return <div></div>;
};

export default Payment;
